import { createFileRoute } from "@tanstack/react-router";

import { MorrowVaultPage } from "../components/vault/MorrowVaultPage";

export type VaultSearch = {
  readonly item?: string;
};

export const Route = createFileRoute("/vault")({
  validateSearch: (raw: Record<string, unknown>): VaultSearch => ({
    ...(typeof raw.item === "string" && raw.item ? { item: raw.item.slice(0, 120) } : {}),
  }),
  component: MorrowVaultPage,
});
